import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@env/environment';

export const featureEnabled = (feature: keyof typeof environment.features): CanActivateFn => {
    return () => {
        return environment.features[feature] || inject(Router).createUrlTree(['/dashboard']);
    };
};
